module.exports = __webpack_public_path__ + "static/media/GBTM.f8d99395.jpg";